export const STORAGE_KEYS = {
  PROGRESS: 'educat_v3_progress',
  TEACHER_MODE: 'educat_teacher_mode',
};
